import { Container, Grid } from "@mui/material";
import { format } from "date-fns";
import React, { Fragment } from "react";
import { ResCard } from "../Global/ResCard";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../firebase";

const GOLD = "#ffc000";
const PRIMARY = "#000c66";

export const ArticleSection = () => {
  const [articles, setArticles] = React.useState([]);

  const getArticles = async () => {
    try {
      const q = query(collection(db, "articles"), orderBy("createdAt", "desc"));
      const snap = await getDocs(q);
      setArticles(
        snap.docs.map((d) => ({
          _id: d.id,
          ...d.data(),
          createdAt: d.data().createdAt?.toDate() || new Date(),
        }))
      );
    } catch (err) {
      console.error(err.message);
    }
  };

  React.useEffect(() => {
    getArticles();
  }, []);

  const slice = articles.slice(0, 3);

  return (
    <Fragment>
      <div className="bg-gray-100 pb-10">
        {/* Header */}
        <div className="flex flex-col items-center text-center pt-16 pb-10 px-4">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-px w-8" style={{ background: `${GOLD}88` }} />
            <p
              className="font-abel uppercase tracking-[0.4em] text-xs"
              style={{ color: GOLD }}
            >
              The Word
            </p>
            <div className="h-px w-8" style={{ background: `${GOLD}88` }} />
          </div>

          <h2
            className="font-aref font-bold leading-tight"
            style={{
              color: PRIMARY,
              fontSize: "clamp(1.75rem, 3.5vw, 2.8rem)",
            }}
          >
            Latest <span style={{ color: GOLD }}>Articles</span>
          </h2>

          <div className="my-5 flex items-center gap-3" style={{ width: 200 }}>
            <div className="flex-1 h-px" style={{ background: `${GOLD}55` }} />
            <svg viewBox="0 0 24 24" width={12} height={12} fill={GOLD}>
              <path d="M9 0h6v7h9v6h-9v11H9V13H0V7h9z" />
            </svg>
            <div className="flex-1 h-px" style={{ background: `${GOLD}55` }} />
          </div>

          <p
            className="font-abel text-base"
            style={{ color: "#888", maxWidth: 460 }}
          >
            Understand the way of God and digest the word daily.
          </p>
        </div>

        <Container>
          <Grid item={true} container spacing={3} justifyContent="center" className="">
            {slice.map((article, index) => (
              <Grid item={true} xs={12} sm={6} md={4} lg={4} key={index}>
                <ResCard
                  image={article.imgSrc}
                  title={article.title}
                  btnName="Read More"
                  date={format(new Date(article.createdAt), "d, MMMM yyyy")}
                  path={`/articles/view/${article.slug}`}
                  comment={article.commentCount}
                  iconText={article.author}
                  authorImg={article.authorImg}
                  phrase={article.phrase}
                />
              </Grid>
            ))}
          </Grid>
        </Container>
      </div>
    </Fragment>
  );
};
